import {Fragment, useEffect, useRef, useState} from 'react';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import {filterStringArray, FilterTextfield} from '../pin_management';
import {
    Button,
    Checkbox,
    FormControlLabel,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import {ColumnTypes} from '../hl7/hl7_messages_comp';
import {useTranslation} from 'react-i18next';
import API from '../../../app/api';
import {useDispatch} from 'react-redux';
import {setLoading} from '../../../store/reducers/patient';
import _ from 'lodash';
import MessageBox from '../../../util/messageBox';
import AgyleButton from '../../../components/ui/buttons/agyleButton';
import AgyleTextField from '../../../components/ui/fields/agyleTextField';
import AgyleDialog from '../../../components/modal/agyleDialog';
import {AgyleNamedIcon} from '../../../components/icons/agyle';
import AgyleDictionaryField from '../../../components/ui/selector/agyleDictionaryField';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import {useDebounce} from 'use-debounce';
import moment from 'moment/moment';
import {escapeRegExp} from '../../ward/forms/formsUtil';
import {useWebSocket} from '../../../context/WebSocketProvider';

const columnToSearch = ['userName', 'fullName'];
const CHANNELS = ["db_audits_auditType.description_setPinCode", "db_audits_auditType.description_deletePinCode"];

const ControlUsername = (props) => {
    const {t} = useTranslation();

    // Options
    const [opt, setOpt] = useState([]);
    const [loading, setLoading] = useState(false);

    const [search, setSearch] = useState('');
    const [searchValueDebounced] = useDebounce(search, 250);
    const controller = new AbortController();

    useEffect(() => {
        return () => {
            controller.abort();
        };
    }, []);

    useEffect(() => {
        if (!_.isEmpty(searchValueDebounced) || props.surgery) {
            let filter = '';
            let paging = '';

            if (props.dontTrimSearch) {
                filter = getFilter(searchValueDebounced, filter, escapeRegExp);
            } else {
                for (let term of searchValueDebounced.split(" ")) {
                    filter = getFilter(term, filter, escapeRegExp);
                }
            }

            paging = '&$pageSize=100&$page=1&$sort=userName';


            API.getUsers(`?$filter=${encodeURIComponent(filter)}${paging}`, controller.signal)
              .then(dictData => {
                  if (dictData && dictData.data.__data && !_.isEmpty(dictData.data.__data)) {
                      let data = dictData.data.__data;
                      setOpt(data);
                  } else {
                      setOpt([]);
                  }
                  setLoading(false);
              });
        }
        return () => {
        };
    }, [searchValueDebounced, props.surgery]);

    function getFilter(input, filter) {
        if (!_.isEmpty(input)) {
            if (!_.isEmpty(filter)) filter += ' AND ';
            for (let i = 0; i < columnToSearch?.length; i++) {
                if (i > 0) {
                    filter += ' or ';
                }
                filter += `${columnToSearch[i]} regex '.*` + escapeRegExp(input) + `.*'`;
            }
        }
        return filter;
    }

    const getVal = (value) => {
        if (value && value !== 'null') return value;
        return '';
    };

    const renderOptionLine = (props, option, test) => {
        return (
          option.userName
        )
    };

    const renderLabel = (option) => {
        return (
          `${getVal(option?.userName)}`)
    };

    const handleInputChange = (_e, val) => {
        setSearch(val);
    };

    const handleChange = (e, val) => {
        props.onChange(val, e);
    };

    return (
      <AgyleDictionaryField
        label={props.label}
        options={opt}
        onChange={handleChange}
        value={props.value}
        onInputChange={handleInputChange}
        // getOptionLabel={option => option.userName}
        getOptionLabel={renderLabel}
        // renderLocalOption={renderOptionLine}
        isOptionEqualToValue={(opt, val) => opt.userName === val.userName}
        size={props.size || 'medium'}
        loading={loading}
        disabled={props.disabled}
      />
    );
};

const DeviceDialog = (props) => {
    const {t} = useTranslation();
    // const initialDeviceState = {
    //     userName: "",
    //     pin: ""
    // }
    const [deviceState, setDeviceState] = useState(null);
    const [usernameInput, setUsernameInput] = useState("");
    const [usernameDebounced] = useDebounce(usernameInput, 250);

    const [allUsers, setAllUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const agyleDialogText = props.user ? "Edit PIN" : "Add PIN";
    const textInputValue = props.user ? props.user?.userName : deviceState?.deviceName;

    const generatePin = (len) => {
        const randomString = (length, chars) => {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
            return result;
        }

        setDeviceState(prevState => ({
            ...prevState,
            pin: randomString(len, '0123456789')
        }))
    }

    const handleClose = () => {
        // setDeviceState(initialDeviceState);
        setDeviceState(null);
        props.close();
    }

    const handleSave = () => {
        if (!atLeastOneInputFilled() || !deviceState?.pin) {
            return props.renderErrorSnackbar("Please provide all required fields.");
        }
        if (deviceState?.pin?.length !== 6) {
            return props.renderErrorSnackbar("Pin must be 6 digits long.");
        }
        props.save(usernameInput || textInputValue || deviceState?.deviceName || deviceState?.userName, deviceState.pin);
        handleClose();
    }

    const handleChangePinCode = (e) => {
        const { value } = e.target;
        
        setDeviceState(prevState => ({
            ...prevState,
            pin: value
        }));
    }

    const getAllUsers = (filter) => {
        setIsLoading(true)
        try {
            API.getUsers(filter).then(apiResponse => {
                if (apiResponse.status === 200) {
                    if (apiResponse?.data?.__data) {
                        setAllUsers(apiResponse?.data?.__data);
                    } else {
                        setAllUsers([]);
                    }
                }
            });
        } catch (e) {
            props.renderErrorSnackbar("Error fetching data. Please try again later.")
        }
        finally {
          setIsLoading(false)
        }
    }

    const handleChangeUserNameModal = (e) => {
        //   ?activeOnly=true&$pageSize=100&$sort=userName&$filter=userName regex 'gord'
        let filterStr = "?$pageSize=100&$sort=userName&$page=1";
        filterStr += e ? `&$filter=userName regex '${escapeRegExp(e)}' or fullName regex '${escapeRegExp(e)}'` : "";

        getAllUsers(filterStr);
    }


    useEffect(() => {
        if (props.user) {
            setDeviceState(prevState => ({
                ...prevState,
                ...props.user
            }));
        }
    }, [props.user, props.open])

    // useEffect(() => {
    //     console.log("Input val to search", usernameInput);
    //     // props.onUsersChange(usernameDebounced);
    //     handleChangeUserNameModal(usernameInput);
    // }, [usernameDebounced])

    useEffect(() => {
        if (!props.user) {
            getAllUsers();
        }
    }, []);

    const userOption = props?.userList || [];
    const allUsersOptions = props?.users || [];


    const [open, setOpen] = useState(false);
    
    const handleOpenInput = () => {
      setOpen(true);
    }
    
    const handleCloseInput = () => {
      setOpen(false);
    }


    const renderDictionaryInput = () => (props.user ? (
      <AgyleDictionaryField
        // options={props?.userList || []}
        options={userOption}
        onChange={(_, value) => {
            setDeviceState(value);
        }}
        label={t("User Name")}
        getOptionLabel={(option) => option.userName}
        value={deviceState}
        disabled={props.user}
      />) :
        (
          <ControlUsername
            label={t('Username')}
            // disabled={checkDisabled()}
            size="small"
            value={deviceState}
            onChange={(e) => setDeviceState(e)}
            dontTrimSearch
          />
        )
      // (<AgyleDictionaryField
      //   key={allUsers?.length}
      //   options={allUsers}
      //   onChange={(_, value) => {
      //       setDeviceState(value);
      //   }}
      //   open={open}
      //   onOpen={handleOpenInput}
      //   onClose={handleCloseInput}
      //   inputValue={usernameInput}
      //   onInputChange={(_, value) => {
      //       setOpen(true)
      //       setUsernameInput(value);
      //   }}
      //   label={t("User Name")}
      //   getOptionLabel={(option) => option.userName}
      //   value={deviceState}
      //   loading={isLoading}
      //   disabled={props.user}
      //   // filterOptions={(options, state) => options}
      //   // isOptionEqualToValue={(option, value) => option.userName === value.userName}
      // />)
    );

    const atLeastOneInputFilled = () => {
        return deviceState?.userName || usernameInput;
    }
    return (
        <AgyleDialog
            title={t(agyleDialogText)}
            open={props.open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            // disableSubmit={!usernameInput ||!deviceState?.userName || !deviceState?.pin || deviceState?.pin?.length !== 6}
            disableSubmit={!atLeastOneInputFilled() || !deviceState?.pin || deviceState?.pin?.length !== 6}
            onSave={handleSave}
            disableEscapeKeyDown
            onBackdropClick={(e) => {
                e.stopPropagation();
                return;
            }}
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    {renderDictionaryInput()}



                    {/*{!props.user && <AgyleTextField*/}
                    {/*  size={"large"}*/}
                    {/*  multiline*/}
                    {/*  fullWidth*/}
                    {/*  size="small"*/}
                    {/*  label={t("Username")}*/}
                    {/*  value={usernameInput}*/}
                    {/*  onChange={(e) => setUsernameInput(e.target.value)}*/}
                    {/*/>*/}
                    {/*}*/}


                </Grid>

                <Grid item xs={12} style={{flexBasis: 'content'}}>
                    <AgyleButton
                        variant="contained"
                        color="primary"
                        size="large"
                        onClick={() => generatePin(6)}
                    >
                        Generate Pin
                    </AgyleButton>
                </Grid>

                <Grid item xs={6.8} sm={9.2} style={{flexGrow: 2}}>
                    <AgyleTextField
                        label="PIN (6 digits)"
                        type="number"
                        value={deviceState?.pin || ""}
                        onChange={handleChangePinCode}
                        size="small"
                        readOnly
                        fullWidth
                    />
                </Grid>
            </Grid>
    </AgyleDialog>)
}

const UsersPin = (props) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const {manageSubscription, message} = useWebSocket();

    // Initial state values
    const [filterValue, setFilterValue] = useState("");
    const [deviceData, setDeviceData] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [filteredDeviceData, setFilteredDeviceData] = useState([]);
    const [activeUsers, setActiveUsers] = useState(false);

    const userRef = useRef(null);

    // Dialog state
    const [isRemoveDeviceDialogOpen, setIsRemoveDeviceDialogOpen] = useState(false);
    const [isAddDeviceDialogOpen, setIsAddDeviceDialogOpen] = useState(false);

    useEffect(() => {
        manageSubscription(CHANNELS);
    }, []);

    const getData = async () => {
        dispatch(setLoading(true))
        try {
            const apiResponse = await API.getUserPin();
            setDeviceData(apiResponse.data.__data);
            setFilteredDeviceData(apiResponse.data.__data);
        } catch (err) {
            props.renderErrorSnackbar("Error fetching data. Please try again later.");
        } finally {
            dispatch(setLoading(false));
        }
    }

    const getAllUsers = (filter) => {
        API.getUsers(filter).then(res => {
            setAllUsers(res.data.__data);
            // console.log("RES", res);
        }).catch(e => props.renderErrorSnackbar("Error fetching data. Please try again later."));
    }
    const handleChangeUserNameModal = async (e) => {
        //   ?activeOnly=true&$pageSize=100&$sort=userName&$filter=userName regex 'gord'
        // let filterStr = "?activeOnly=true&$pageSize=100&$sort=userName";
        let filterStr = "?$pageSize=100&$sort=userName&$page=1";
        filterStr += e ? `&$filter=userName regex '${escapeRegExp(e)}' or fullName regex '${escapeRegExp(e)}'` : "";

        getAllUsers(filterStr);
    }

    const deleteRef = () => {
        const timeout = setTimeout(() => userRef.current = null, 400)
        return () => clearTimeout(timeout);
    }

    const openConfirmRemoveUser = (user) => {
        setIsRemoveDeviceDialogOpen(true);
        userRef.current = user
    }

    const closeConfirmRemoveUser = () => {
        setIsRemoveDeviceDialogOpen(false);
        deleteRef();
    }

    const openUserDialog = (user) => {
        if (user) {
            userRef.current = user;
        }
        setIsAddDeviceDialogOpen(true);
    }
    const closeUserDialog = () => {
        setIsAddDeviceDialogOpen(false);
        deleteRef();
    }


    const parseBooleanValue = (bool) => bool ? "Active" : "Disabled";
    const getIcon = (bool) => bool ? <CheckIcon style={{color: "#4EAC6F"}}/> : <CloseIcon style={{color: "#E25B61"}}/>;

    const filterTextValue = (value) => filterStringArray(value, 'userName', deviceData, setFilteredDeviceData);

    const filterActiveUsers = (_, value) => {
        let filtered;
        if (value) {
            filtered = deviceData.filter(device => device.active);
        }

        setActiveUsers(value);
        setFilteredDeviceData(filtered ? filtered : deviceData);
    }

    const removePin = async (deviceId) => {
        dispatch(setLoading(true));
        try {
            API.deactivateUserPin(deviceId).then(res => {
                props.renderSuccessSnackbar("Device untrusted successfully");
                closeConfirmRemoveUser();
                getData();
            })
        } catch (e) {
            props.renderErrorSnackbar("Error untrusting device. Please try again later.");
        } finally {
            dispatch(setLoading(false));
        }
    }

    const saveUserData = (username, pin) => {
        props.onSetUserPin(username, pin).then(() => getData());
        // getData();
    }

    useEffect(() => {
        getData();
        getAllUsers();
    }, []);

    useEffect(() => {
        if (message) {
            getData();
        }
    },[message])

    useEffect(() => {
        console.log("Use effect",deviceData,allUsers);
        let fullDeviceData = deviceData;
        if(deviceData && allUsers) {
            fullDeviceData = [];
            deviceData.forEach((dd) => {
                let user = allUsers.find((u) => u.userName === dd.userName);
                if(user) {
                    dd.fullName = user.fullName;
                    dd.lastSuccessfulLoginDate = (moment(user.lastSuccessfulLoginDate).isValid() ?
                        moment(user.lastSuccessfulLoginDate).format("YYYY-MM-DD HH:mm") : "-")
                    dd.lastSucessfulLoginPin = (moment(dd.lastSucessfulLogin).isValid()  ?
                        moment(dd.lastSucessfulLogin).format("YYYY-MM-DD HH:mm") : "-");
                }
                fullDeviceData.push(dd);
            })
        }
        if (activeUsers) {
            setFilteredDeviceData(fullDeviceData.filter(device => device.active));
        } else {
            setFilteredDeviceData(fullDeviceData);
        }
    }, [deviceData,allUsers])


    const devicesColumns = [
        {
            name: 'userName',
            order: 1,
            value: 'userName',
            type: ColumnTypes.TEXT,
            description: 'User Name',
            minWidth: "20%",
            maxWidth: 40,
            width: '20%',
        },
        {
            name: 'fullName',
            order: 1,
            value: 'fullName',
            type: ColumnTypes.TEXT,
            description: 'Full Name',
            minWidth: "20%",
            maxWidth: 40,
            width: '20%',
        },
        {
            name: 'date',
            order: 1,
            value: 'date',
            valueFunc: (row) => {
                return (<Fragment>
                    <div>{row.lastSuccessfulLoginDate}</div>
                    <div  style={{fontStyle: "italic"}}>({row.lastSucessfulLoginPin})</div>
                </Fragment>)
            },
            type: ColumnTypes.FUNC,
            description: 'Last login date / Last PIN login date',
            descriptionFun: () => { return (<Fragment><div>Last login date</div>
                <div style={{fontStyle: "italic"}}>(Last PIN login date)</div></Fragment>) },
            minWidth: "20%",
            width: '20%',
        },
        {
            name: 'active',
            order: 1,
            value: 'active',
            type: ColumnTypes.TEXT,
            description: 'Active',
            minWidth: "15%",
            width: '15%',
        },

        {
            name: 'actions',
            order: 1,
            value: 'actions',
            type: ColumnTypes.ACTIONS,
            description: 'Actions',
            minWidth: "15%",
            width: '15%',
            actionList: [
                {
                    callback: openUserDialog,
                    buttonLabel: "Edit User",
                    icon: 'editPencil',
                    iconColor: '#2180F7'
                },
                {
                    callback: openConfirmRemoveUser,
                    buttonLabel: "Deactivate User",
                    icon: 'removeBin',
                    iconColor: '#E25B61'
                }
            ],
        },
    ]

    const renderButtons = (btns, row) => {
        let buttons = [];
        for (let action of btns.actionList) {

            if (!row.active && action.icon === 'removeBin') continue;
            buttons.push(
                <Button
                    key={action.buttonLabel+action.iconColor}
                    style={{
                        color: action.iconColor,
                        boxShadow: '0 0 5px rgba(0, 0, 0, 0.25)',
                        marginRight: action.icon === 'editPencil' ? "10px" : "",
                    }}
                    onClick={() => action.callback(row)}
                >
                    <AgyleNamedIcon
                        style={{display: 'flex'}}
                        name={action.icon}
                        customTooltip={action.buttonLabel}
                        withTooltip
                    />
                </Button>
            )
        }
        return buttons;
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} style={{display: 'flex', alignItems: 'center', paddingTop: 0, paddingLeft: 0}}>
                <FilterTextfield onChange={setFilterValue} value={filterValue} findValues={filterTextValue}/>

                <FormControlLabel
                    sx={{mt: 2}}
                    control={ <Checkbox

                        checked={activeUsers}
                        onChange={filterActiveUsers}
                    />}
                    label="Show only Active" />

                <AgyleButton
                    onClick={() => openUserDialog()}
                    variant="contained"
                    style={{marginLeft: 'auto', marginRight: 0, marginTop: 6  }}
                >
                    {t("Add new record")}
                </AgyleButton>
            </Grid>

            <Grid item xs={12} style={{margin:0, padding:0}}/>

            <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead key={"HEAD"} sx={{border: 1}}>
                        {devicesColumns.map((column) => (
                            <TableCell
                                key={column.name}
                                align={column.align}
                                style={{
                                    width: column.width,
                                    border: "1px solid #80808035",
                                }}>
                                <Grid container justifyContent="space-between">
                                    <Typography variant="subtitle2" color="textSecondary">
                                        {((column.descriptionFun) ?  column.descriptionFun() : column.description)}
                                    </Typography>
                                </Grid>
                            </TableCell>
                        ))}
                    </TableHead>

                    <TableBody>
                        {!_.isEmpty(filteredDeviceData) && filteredDeviceData.map((row, index) => {
                            return (
                                <TableRow
                                    hover
                                    tabIndex={-1}
                                    key={row.__id}
                                >
                                    {devicesColumns.map((column) => {
                                        const value = row[column.value];

                                        return (
                                            <TableCell
                                                key={column.name+value}
                                                align={column.align}
                                            >
                                                {column.type === ColumnTypes.FUNC && column.valueFunc(row)}
                                                {column.type === ColumnTypes.TEXT && value}
                                                {column.name === 'active' && getIcon(row?.active)}
                                                {column.type === ColumnTypes.ACTIONS && renderButtons(column, row)}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
                {_.isEmpty(filteredDeviceData) &&
                    <Typography
                        variant="subtitle1"
                        align="center"
                        mt={2}
                    >No devices found.</Typography>
                }
            </TableContainer>


            <MessageBox
                open={isRemoveDeviceDialogOpen && userRef?.current}
                onClose={closeConfirmRemoveUser}
                title={t('Confirmation')}
                message={t(`Are you sure you want to remove a PIN for a user <b>${userRef?.current?.userName ? userRef?.current?.userName : ""}</b>?`)}
                haveAccept={{yes: t('Yes'), no: t('No')}}
                onAccept={() => removePin(userRef.current?.__id)}
                warning
            />

            {
                <DeviceDialog
                    user={userRef.current}
                    users={allUsers}
                    open={isAddDeviceDialogOpen}
                    close={closeUserDialog}
                    save={saveUserData}
                    userList={deviceData}
                    {...props}
                />
            }
        </Grid>
    )
}

export default UsersPin;
// Mam problem z Autocomplete w połączeniu z debounced value. Przykładowo, wpisuję w inputa "gordon", API zwraca arraya 3 elementowego z userami które zawierają "gordon" w atrybucie userName. Przypisuje ta tablice do jakiejs tam wartosci, zalozmy "allUsers". Kiedy loguje allUsers to wyświetla się rzeczywiście 3 elementowy array, ale opcji Autocomplete wyświetla znaaaacznie więcej. O ile masz chwilę to mogę zadzwonić i pokazać Ci na żywo jak to wygląda.